import {     DELETE_BATCH, DELETE_BATCH_SUCCESS, DELETE_BATCH_ERROR, USERS_LIST, USERS_LIST_SUCCESS, USERS_LIST_ERROR, MESSAGES_LIST, MESSAGES_LIST_SUCCESS, MESSAGES_LIST_ERROR, ADD_MESSAGE, ADD_MESSAGE_SUCCESS, ADD_MESSAGE_ERROR, EDIT_MESSAGE, EDIT_MESSAGE_SUCCESS, EDIT_MESSAGE_ERROR, MESSAGE_DETAILS, MESSAGE_DETAILS_SUCCESS, MESSAGE_DETAILS_ERROR } from './constants';


export default function CommunicationDataReducer(state, action) {
    
	let batch = [];
	// let questions = [];

	switch (action.type) {

	case MESSAGES_LIST:
		return { ...state, loading : true, error : false};

	case MESSAGES_LIST_SUCCESS:
		if(action?.payload){
			action.payload.map((item) => {
                
				batch.push({
					id : item && item?.id ? item.id : null,
					text : item && item?.text ? item.text : '',
					toUsers : item && item?.touserIds ?  item.touserIds : null,
					toUserNames :  item?.touserNames?.join(', '),
					regioninfoId : item && item?.regioninfoId ? item.regioninfoId : null,
					regionName : item?.regioninfo?.regionName ? item.regioninfo.regionName : null
                    
				});
			});
		}

		return {...state, batch : batch,  loading : false, error : false};

	case MESSAGES_LIST_ERROR:
		return { ...state, batch : [], loading : false, error : true};

	case ADD_MESSAGE:
		return { ...state, loading: true };
	case ADD_MESSAGE_SUCCESS:
		return { ...state, loading: false, error: false };

	case ADD_MESSAGE_ERROR:
		return {...state, loading : false, error : true};

	case EDIT_MESSAGE:
		return { ...state, loading: true, error: false };

	case EDIT_MESSAGE_SUCCESS:
		return { ...state,  loading: false, error : false };

	case EDIT_MESSAGE_ERROR:
		return {...state, loading : false, error : true};

	case MESSAGE_DETAILS:
		return { ...state, loading: true };

	case MESSAGE_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };

	case MESSAGE_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case DELETE_BATCH:
		return { ...state, loading: false };

	case DELETE_BATCH_SUCCESS:
		return { ...state, loading: false, error: false };

	case DELETE_BATCH_ERROR:
		return { ...state, loading: false, error: true };

	

	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS:
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true, pending: false };

	default: 
		throw Error('Unknown action: ' + action.type);
      
	}
}